(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.collection-card[data-hover-scheme]').forEach(function(el) {
    var hoverScheme = el.dataset.hoverScheme;
    var baseScheme = el.dataset.baseScheme;

    el.addEventListener('mouseenter', function() {
      if (baseScheme) el.classList.remove('color-' + baseScheme);
      el.classList.add('color-' + hoverScheme);
    });

    el.addEventListener('mouseleave', function() {
      el.classList.remove('color-' + hoverScheme);
      if (baseScheme) el.classList.add('color-' + baseScheme);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.group-block[data-hover-scheme]').forEach(function(el) {
    var hoverScheme = el.dataset.hoverScheme;
    var baseScheme = el.dataset.baseScheme;

    el.addEventListener('mouseenter', function() {
      if (baseScheme) el.classList.remove('color-' + baseScheme);
      el.classList.add('color-' + hoverScheme);
    });

    el.addEventListener('mouseleave', function() {
      el.classList.remove('color-' + hoverScheme);
      if (baseScheme) el.classList.add('color-' + baseScheme);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mouseover', function(e) {
    var el = e.target.closest('.product-card__content[data-hover-scheme]');
    if (!el || el._hoverActive) return;
    el._hoverActive = true;
    var baseScheme = el.dataset.baseScheme;
    if (baseScheme) el.classList.remove('color-' + baseScheme);
    el.classList.add('color-' + el.dataset.hoverScheme);
  });

  document.addEventListener('mouseout', function(e) {
    var el = e.target.closest('.product-card__content[data-hover-scheme]');
    if (!el) return;
    var related = e.relatedTarget;
    if (related && el.contains(related)) return;
    el._hoverActive = false;
    el.classList.remove('color-' + el.dataset.hoverScheme);
    var baseScheme = el.dataset.baseScheme;
    if (baseScheme) el.classList.add('color-' + baseScheme);
  });
  } catch(e) { console.error(e); }
})();

})();
